/* eslint-disable import/prefer-default-export */
export const rootNode = {
  treeKey: '1',
  type: 'root',
  orderbyIndex: 1,
};

export const defaultProps = {
  treeKey: 'treeKey',
  children: 'children',
  label: 'label',
  isLeaf: 'leaf',
};
export const TREE_TYPE_DELIMETER = '-';
export const TREE_KEY_DELIMETER = '.';
export const PHYSICAL_ETC_KEY = '_etc';
export const PREFIX_OBJ_KEY = 'O';

export const treeType = {
  GRID_DASHBOARD: 'grid_dashboard',
  COORD_DASHBOARD: 'coord_dashboard',
  LOGICAL: 'logical',
  PHYSICAL: 'physical',
  LOG: 'log',
  LOG_FILTER: 'log_filter',
  LOG_INDEX: 'log_index',
  REPORT: 'report',
};

export const treeNodeType = {
  GROUP: 'group',
  OBJ: 'obj',
};

export const treeNodeSubType = {
  SERVER: 'server',
  NETDEVICE: 'netdevice',
  AP_CONTROLLER: 'ap_controller',
  WIRELESS_AP: 'wireless_ap',
  NETINTERFACE: 'netinterface',
  DBMS: 'dbms',
  E2E: 'e2e',
  SERVICE: 'service',
  SENSOR: 'sensor',
  VIRTUAL: 'virtual',
  APM: 'apm',
};



// WEBPACK FOOTER //
// ./src/constants/tree.js